/**
 * Custom Variant Filtering
 *
 * Shopify's native value.available only cascades from earlier to later options.
 * This script adds bidirectional filtering: when a later option (e.g. Styrke)
 * is selected, earlier options (e.g. Farve) are also updated to reflect
 * which values have available variants for the current selection.
 *
 * Uses MutationObserver to re-apply filtering after product-info.js swaps
 * the variant-selects HTML via AJAX section rendering.
 */
(function () {
  let productData = null;

  function getProductHandle() {
    const url = window.location.pathname;
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  async function fetchProductData() {
    const handle = getProductHandle();
    if (!handle) return null;
    try {
      const resp = await fetch(`/products/${handle}.js`);
      return await resp.json();
    } catch (e) {
      console.error('custom-variant-filtering: failed to fetch product data', e);
      return null;
    }
  }

  function getSelectedValues(variantSelects) {
    const selected = {};
    variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
      const legend = fieldset.querySelector('legend, .form__label');
      if (!legend) return;
      const optionName = legend.textContent.replace(/:.*$/, '').trim();
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) selected[optionName] = checked.value;
    });
    return selected;
  }

  function updateOptionAvailability(variantSelects) {
    if (!productData) return;

    const selected = getSelectedValues(variantSelects);
    const options = productData.options;

    options.forEach((option) => {
      const optionPosition = option.position;

      const inputs = variantSelects.querySelectorAll(
        `fieldset:nth-of-type(${optionPosition}) input[type="radio"]`
      );

      inputs.forEach((input) => {
        const testValue = input.value;

        const hasAvailable = productData.variants.some((variant) => {
          if (!variant.available) return false;
          if (variant[`option${optionPosition}`] !== testValue) return false;

          return options.every((otherOption) => {
            if (otherOption.position === optionPosition) return true;
            const selectedVal = selected[otherOption.name];
            if (!selectedVal) return true;
            return variant[`option${otherOption.position}`] === selectedVal;
          });
        });

        if (hasAvailable) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    });
  }

  function observeVariantSelects() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const observer = new MutationObserver(() => {
      const vs = productInfo.querySelector('variant-selects');
      if (vs) updateOptionAvailability(vs);
    });

    observer.observe(productInfo, { childList: true, subtree: true });
  }

  async function init() {
    productData = await fetchProductData();
    if (!productData || productData.variants.length <= 1) return;

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    updateOptionAvailability(variantSelects);
    observeVariantSelects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
